import { render, staticRenderFns } from "./SearchResultPage.vue?vue&type=template&id=23a9cdec&scoped=true"
import script from "./SearchResultPage.vue?vue&type=script&lang=js"
export * from "./SearchResultPage.vue?vue&type=script&lang=js"
import style0 from "./SearchResultPage.vue?vue&type=style&index=0&id=23a9cdec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9cdec",
  null
  
)

export default component.exports